"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ErrorMessages = function ErrorMessages(_ref) {
  var messages = _ref.messages;
  var messageNodes = messages.map(function (message, key) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _react["default"].createElement("span", {
        key: key,
        className: "help-block validation-message"
      }, message)
    );
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, messageNodes);
};

ErrorMessages.propTypes = {
  messages: _propTypes["default"].arrayOf(_propTypes["default"].node)
};
ErrorMessages.defaultProps = {
  messages: []
};
var _default = ErrorMessages;
exports["default"] = _default;